module.exports = __webpack_public_path__ + "static/media/wave1.05d52988.png";